__webpack_require__.p = "/tga2025/";